module.exports = __webpack_public_path__ + "img/three_quarter_tip.23f9f9af.jpg";